import fetch from './fetch'

export default {
    getVictimInfo (payload) {
        const request = fetch({
            url: '/victiminfo',
            method: 'get',
            data: {},
            payload
        })

        return request.call()
    },

    updateVictimInfo (payload) {
        const request = fetch({
            url: '/victiminfo/create/',
            method: 'post',
            data: payload
        })

        return request.call()
    }
}



// WEBPACK FOOTER //
// ./src/api/victimInfo.js